import { render, staticRenderFns } from "./InList.vue?vue&type=template&id=638d1d49&"
import script from "./InList.vue?vue&type=script&lang=js&"
export * from "./InList.vue?vue&type=script&lang=js&"
import style0 from "./InList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports